// #region imports
import React, {  Component }      from 'react';
import { withRouter }           from 'react-router';

class RestrictedAccess extends Component {

  render() {

    return (
        <div className="row">
          <div className="col-lg-12 user-list list-page">
            <div className="panel">
              <header className="panel-heading">Restricted Area</header>
              <div className="panel-body">
                <div className="clearfix" />
                <div className="row">
                  <div className="col-lg-12">
                    You are not permitted to Access this Location. Please contact to Admin
                  </div>
                </div>
                <div className="clearfix" />
              </div>
            </div>
          </div>
        </div>
      );
  }

}

export default (withRouter)(RestrictedAccess);


// WEBPACK FOOTER //
// ./src/app/views/RestrictedAccess.js